module.exports = __webpack_public_path__ + "static/img/applicableScene6.40cd663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene6.png
// module id = Sb/D
// module chunks = 0